import { useTranslation } from "react-i18next";
import "./accountInfo.scss";
import MainLayout from "../../../layouts/layout";
import { Breadcrumb, Button, Col, Form, Input, Row, Select } from "antd";
import { _adr } from "../../../../address";
import { HomeOutlined } from "@ant-design/icons";
import { Content } from "antd/es/layout/layout";
import ReactInputMask from "react-input-mask";
const AccountInfo = () => {
  const [t] = useTranslation("global");
  const [frmAcountInfo] = Form.useForm();
  const handleSubmit = async () => {
    try {
      let valid = await frmAcountInfo.validateFields();
      if (valid) {
      }
    } catch (error) {}
  };
  return (
    <>
      <div className="holder-top-page-layout">
        <Breadcrumb
          className="breadcrumbs"
          items={[{ href: _adr.Root + _adr.Home, title: <HomeOutlined /> }, { title: t("acounts.accountinfo.title") }]}
        />
      </div>
      <div className="holder-descript-page">
        <h3>{t("acounts.accountinfo.title")}</h3>
      </div>
      <Content className="bg-container">
        <div className="row-content-form">
          <div className="content-area">
            <div className="holder-account-info-page">
              <Form form={frmAcountInfo} layout="vertical">
                <Row gutter={15}>
                  <Col span={8}>
                    <Form.Item
                      name="bankname"
                      label="نام بانک"
                      rules={[
                        {
                          required: true,
                          message: t("validation.required"),
                        },
                      ]}
                    >
                      <Select className="selectdrd" placeholder="نام بانک را وارد کنید">
                        <Select.Option className="opt-select">بانک سامان</Select.Option>
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={8}>
                    <Form.Item
                      name="acountnumber"
                      label="شماره حساب بانکی"
                      rules={[
                        {
                          required: true,
                          message: t("validation.required"),
                        },
                        {
                          validator: (_, value) => {
                            let _regex = new RegExp(t("validation.regexDigit"));
                            if (!_regex.test(value)) {
                              return Promise.reject(t("validation.number"));
                            }
                            return Promise.resolve();
                          },
                        },
                      ]}
                    >
                      <Input dir="ltr" placeholder="شماره حساب بانکی را وارد کنید" />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={15}>
                  <Col span={8}>
                    <Form.Item
                      name="cardnumber"
                      label="شماره کارت"
                      rules={[
                        {
                          required: true,
                          message: t("validation.required"),
                        },
                      ]}
                    >
                      <ReactInputMask className="maskinput" dir="ltr" mask="9999-9999-9999-9999" placeholder="شماره کارت را وارد کنید" />
                    </Form.Item>
                  </Col>
                  <Col span={8}>
                    <Form.Item
                      label="شماره شبا"
                      rules={[
                        {
                          required: true,
                          message: t("validation.required"),
                        },
                        {
                          validator: (_, value) => {
                            let _regex = new RegExp(t("validation.regexDigit"));
                            if (!_regex.test(value)) {
                              return Promise.reject(t("validation.number"));
                            }
                            return Promise.resolve();
                          },
                        },
                      ]}
                    >
                      <Input dir="ltr" addonAfter="IR" placeholder="شماره حساب بانکی را وارد کنید" />
                    </Form.Item>
                  </Col>
                </Row>
              </Form>
            </div>
          </div>
          <div className="footer-area">
            <div className="holder-button">
              <Button type="primary" danger onClick={handleSubmit}>
                ثبت
              </Button>
            </div>
          </div>
        </div>
      </Content>
    </>
  );
};

export default AccountInfo;
